export class ApplicationProperty {
    constructor (
        public AddressLine1: string = '',
        public City: string = '',
        public PropertyPhase: string = ''
    ) { }
}
